import LeafletShiftedPositionAutoResizeMarker from './LeafletShiftedPositionAutoResizeMarker';
import { LeafletExtensionGlobalFilterBasedLayer } from './LeafletExtensionGlobalFilterBasedLayer';
import {
  NiLayerOptions,
} from './NIBaseClass/LeafletExtensionNIBaseLayer';
export default class FeaturesRenderingLayer extends LeafletExtensionGlobalFilterBasedLayer {
  constructor(options: NiLayerOptions) {
    super(options);
  }

  protected renderLayerData() {
    this.currentBaseMarkers.forEach((siteMarkerInfo) => {
      let siteMarkerCreated = false;
      siteMarkerInfo.orientations.forEach((orientation) =>
        orientation.markers.forEach((cellMarkerInfo) => {
          this.layerDataFromServer?.data?.features.forEach((geoJsonFeature) => {
            if (
              geoJsonFeature.properties?.['CELL_NATURAL_KEY'] ==
              cellMarkerInfo.id
            ) {
              if (!siteMarkerCreated) {
                siteMarkerCreated = true;
                let marker = new LeafletShiftedPositionAutoResizeMarker(
                  this,
                  geoJsonFeature,
                  cellMarkerInfo.location,
                  0,
                  0
                ).addTo(this.internalLayer);
                marker.bringToFront();
              }
              let marker = new LeafletShiftedPositionAutoResizeMarker(
                this,
                geoJsonFeature,
                cellMarkerInfo.location,
                cellMarkerInfo.orientation,
                cellMarkerInfo.cellIndexWithinOrientation
              ).addTo(this.internalLayer);
              marker.bringToFront();
            }
          });
        })
      );
    });
  }
}